import { render, staticRenderFns } from "./ViInvoiceFeePlan.vue?vue&type=template&id=c0075fce"
import script from "./ViInvoiceFeePlan.vue?vue&type=script&lang=js"
export * from "./ViInvoiceFeePlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports